import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../../../@core/services/data.service';
import { ImageGalleryInterface } from '../../../@core/models/site-material-data.model';
import * as Sentry from "@sentry/browser";


@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialImageGalleryComponent implements OnInit, OnDestroy {

    title = 'Image Gallery';
    subTitle = 'Image Gallery';
    textColor = '';
    backgroundColor = '';
    flexBorderSize = 5;
    flexImageSize = 7;
    galleryName = '';
    metadataUri: string = '';
    subscription: Subscription;
    data: ImageGalleryInterface;
    active: boolean = false;
    position: number = 0;
    moduleInfo: string;
    galleryId: string = '';
    editOn: boolean = false;
    activatePadding: boolean = false;
    siteId: string = '';
    siteName: string = '';
    loading: boolean = true;
    allElementAnimation: string;
    textAnimation: string;
    imagesAnimation: string;

    constructor(
        private dataService: DataService
    ) {
        Sentry.configureScope(function (scope) {
            scope.setTag("component", "HeroVideoComponent");
        });
    }

    ngOnInit(): void {
        if (this.data.animation) {
            this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
            this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
            this.imagesAnimation = this.data.animation.images != '' ? this.data.animation.images : undefined;

        }
        this.loading = false;
        this.subscription = this.dataService.getCurrentSite().subscribe(site => {
            this.siteId = site.siteId;
            this.siteName = site.siteName;
        });
        this.moduleInfo = JSON.stringify({ position: this.position, new: false });
        this.metadataUri = this.data.dataUrl;
        this.title = this.data.title;
        this.subTitle = this.data.subTitle;
        this.textColor = this.data.textColor;
        this.flexBorderSize = this.data.flexBorderSize;
        this.flexImageSize = this.data.flexImageSize;
        this.galleryId = this.data.galleryId;
        this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    }
    onViewerVisibilityChanged(isVisible: boolean): void {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
